import React, { memo, useMemo } from "react";
import { cn } from "../../utils/cn";
import { getTrendIndicator } from "../../utils/scoring";

interface TrendBadgeProps {
    current: number;
    previous?: number | null;
}

export const TrendBadge = memo(function TrendBadge({ current, previous }: TrendBadgeProps) {
    const trend = useMemo(() => getTrendIndicator(current, previous || undefined), [current, previous]);

    if (previous === undefined || previous === null) return null;

    const colorClass = useMemo(() =>
        trend.color === "text-emerald-600" ? "text-emerald-600 dark:text-emerald-400" :
            trend.color === "text-rose-600" ? "text-rose-600 dark:text-rose-400" :
                "text-slate-400 dark:text-slate-500",
        [trend.color]
    );

    return (
        <span className={cn("inline-flex items-center gap-0.5 text-xs font-bold", colorClass)}>
            {trend.icon} {Math.abs(trend.delta).toFixed(1)}
        </span>
    );
});

export default TrendBadge;
